//# sourceMappingURL=text.mjs.map
/// <reference types="./text.d.mts" />
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { rem } from "../../../sketch/sketch/css/length.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

class Regular extends $CustomType {}

class Medium extends $CustomType {}

/**
 * ```css
 * font-weight: 400;
 * ```
 */
export const regular = /* @__PURE__ */ new Regular();

/**
 * ```css
 * font-weight: 500;
 * ```
 */
export const medium = /* @__PURE__ */ new Medium();

function weight_to_font_weight(weight) {
  if (weight instanceof Regular) {
    return "400";
  } else {
    return "500";
  }
}

/**
 * ```css
 * .xl {
 *   font-weight: weight;
 *   font-size: 0.75rem;
 *   line-height: 1.125rem;
 * }
 * ```
 */
export function xl(weight) {
  let weight$1 = weight_to_font_weight(weight);
  return $css.class$(
    toList([
      $css.font_weight(weight$1),
      $css.font_size(rem(1.25)),
      $css.line_height("1.875rem"),
    ]),
  );
}

/**
 * ```css
 * .lg {
 *   font-weight: weight;
 *   font-size: 1.125rem;
 *   line-height: 1.75rem;
 * }
 * ```
 */
export function lg(weight) {
  let weight$1 = weight_to_font_weight(weight);
  return $css.class$(
    toList([
      $css.font_weight(weight$1),
      $css.font_size(rem(1.125)),
      $css.line_height("1.75rem"),
    ]),
  );
}

/**
 * ```css
 * .md {
 *   font-weight: weight;
 *   font-size: 1rem;
 *   line-height: 1.5rem;
 * }
 * ```
 */
export function md(weight) {
  let weight$1 = weight_to_font_weight(weight);
  return $css.class$(
    toList([
      $css.font_weight(weight$1),
      $css.font_size(rem(1.0)),
      $css.line_height("1.5rem"),
    ]),
  );
}

/**
 * ```css
 * .sm {
 *   font-weight: weight;
 *   font-size: 0.875rem;
 *   line-height: 1.25rem;
 * }
 * ```
 */
export function sm(weight) {
  let weight$1 = weight_to_font_weight(weight);
  return $css.class$(
    toList([
      $css.font_weight(weight$1),
      $css.font_size(rem(0.875)),
      $css.line_height("1.25rem"),
    ]),
  );
}

/**
 * ```css
 * .xs {
 *   font-weight: weight;
 *   font-size: 0.75rem;
 *   line-height: 1.125rem;
 * }
 * ```
 */
export function xs(weight) {
  let weight$1 = weight_to_font_weight(weight);
  return $css.class$(
    toList([
      $css.font_weight(weight$1),
      $css.font_size(rem(0.75)),
      $css.line_height("1.125rem"),
    ]),
  );
}
